import React from "react";
import ButtonList from "./ButtonList";
import VideoConatiner from "./VideoConatiner";

const MainContainer = () => {
  return (
    <div className="container ">
     
        <ButtonList />
 
        <VideoConatiner />
      
    </div>
  );
};

export default MainContainer;
